// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1552":"5c181ba7","4912":"6582c33a"}[chunkId] + ".chunk.css";
};